import { Slot } from '@radix-ui/react-slot';
import { cva, type VariantProps } from 'class-variance-authority';
import type * as React from 'react';

import { cn } from '../../styles/lib/utils';

const textVariants = cva('font-noto text-grey-90 font-normal text-sm', {
  variants: {
    variant: {
      default: '',
      numeric: 'font-noto-mono',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

function Text({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<'span'> & VariantProps<typeof textVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : 'span';
  return <Comp data-slot="text" className={cn(textVariants({ variant, className }))} {...props} />;
}

export { Text };
